/**
 * Gets the c2 value from the brand name using the adsNinjaHeaderBiddingManager
 * @returns {string} c2 value
 */
export function getC2(brandName = "Default") {
  var pubIdMap = {
    AndroidPolice: "6035391",
    Moms: "6035391",
    CBR: "6035391",
    HotCars: "6035391",
    TheThings: "6035391",
    MovieWeb: "6035391",
    Default: "21868715"
  };

  return pubIdMap[brandName] || "21868715";
}

/**
 * Pushes the standard Comscore tracking object to _comscore array
 * @param {string} c2 - The c2 ID to use in the tracking object
 */
export function pushComscoreObject(c2) {
  window._comscore = window._comscore || [];

  window._comscore.push({
    c1: "2",
    c2,
    options: {
      enableFirstPartyCookie: true
    }
  });
}

/**
 * Convenience method to run the full Comscore setup
 */
export function initComscore(brandName) {
  var c2 = getC2(brandName);
  pushComscoreObject(c2);

  // Add comscore script to page which will flush the push queue
  var s = document.createElement("script"),
      el = document.getElementsByTagName("script")[0];
  s.async = true;
  s.src = "https://sb.scorecardresearch.com/cs/1234567/beacon.js";
  el.parentNode.insertBefore(s, el);
}
